import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLayoutStore } from '../../../state/layout.store'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'

const SuggestNewCarrierFeedback = ({ message, pkg }: { message: string; pkg: PackageModel }) => {
  const { t } = useTranslation('packages')
  const suggestPkgToggle = useLayoutStore(state => state.carrierSuggestModalToggle)

  const onClick = useCallback(() => {
    suggestPkgToggle(pkg)
  }, [pkg, suggestPkgToggle])

  const suggested = Boolean(pkg.siteContext?.suggested)
  const isLink = Boolean(suggested && typeof pkg.siteContext.suggested === 'string')

  return (
    <div className="p-1 pb-0">
      {isLink && (
        <div className="rounded-2 text-white px-2 d-flex py-custom-1 bg-warning mb-2">
          <div className="flex-grow-1">
            <h4 className="mb-0">{pkg.siteContext.suggested}</h4>
          </div>
          <div className="text-end">
            <a href={pkg.siteContext.suggested + ''} target="_blank" rel="noreferrer" className="text-white">
              <i className="fas fa-external-link-alt" />
            </a>
          </div>
        </div>
      )}
      {!isLink && <p className="mb-2">{message}</p>}
      <p className="text-center mb-1">
        {pkg.siteContext?.suggested && <div>{t('timeline.suggest.suggested')} 🎉</div>}
        {!pkg.siteContext?.suggested && (
          <button className="btn btn-secondary button_pulse" onClick={onClick}>
            {t('timeline.suggest.button')}
          </button>
        )}
      </p>
    </div>
  )
}

export default React.memo(SuggestNewCarrierFeedback)
